// extracted by mini-css-extract-plugin
export default {"tag":"SlantedTag_tag__jt3dT","standardSpacing":"SlantedTag_standardSpacing__pnYUt","unslantIcons":"SlantedTag_unslantIcons__0FAk0"};